import React, { useState } from "react";
import { Box, Code, Collapse, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import { FaChevronDown, FaChevronRight, FaCode } from "react-icons/fa";

export function CodeExecutionBlock({ code, output }) {
  const [isOpen, setIsOpen] = useState(false);
  const codeLineCount = code ? code.split("\n").length : 0;

  return (
    <Box borderWidth="1px" borderRadius="md" overflow="hidden">
      <HStack
        as="button"
        type="button"
        onClick={() => setIsOpen((v) => !v)}
        bg="gray.100"
        color="gray.700"
        _hover={{ bg: "gray.200" }}
        px={3}
        py={1.5}
        spacing={2}
        fontSize="xs"
        fontWeight="medium"
        w="100%"
        textAlign="left"
        cursor="pointer"
      >
        <Icon as={isOpen ? FaChevronDown : FaChevronRight} boxSize="10px" />
        <Icon as={FaCode} />
        <Text fontSize="xs">Code execution</Text>
        <Text fontSize="xs" color="gray.500">
          {codeLineCount} line{codeLineCount === 1 ? "" : "s"}
          {output ? " · output" : ""}
        </Text>
      </HStack>
      <Collapse in={isOpen} animateOpacity>
        <VStack align="stretch" spacing={0}>
          <Box
            as="pre"
            bg="gray.900"
            color="gray.100"
            p={3}
            fontSize="xs"
            fontFamily="mono"
            overflowX="auto"
            whiteSpace="pre"
            m={0}
          >
            {code}
          </Box>
          {output && (
            <Box
              as="pre"
              bg="gray.50"
              borderTopWidth="1px"
              p={3}
              fontSize="xs"
              fontFamily="mono"
              overflowX="auto"
              maxH="240px"
              overflowY="auto"
              whiteSpace="pre"
              m={0}
            >
              {output}
            </Box>
          )}
        </VStack>
      </Collapse>
    </Box>
  );
}

// Re-export Code for downstream use if needed
export { Code };
